import React from "react";
import FacilityArea from "./FacilityArea";
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function CreateFacilityArea({ }) { // Destructuring props

    const [name, setName] = useState('');
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);
    const { projectId } = useParams();
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Log the form data before sending the request
        console.log('Form data:', { name, projectId });

        try {
            const response = await axios.post(`https://light.quant.ac/api/facility_areas/${projectId}/`, null, {
                params: {
                    name: name,
                    projectId: projectId,
                }
            });

            if (response && response.data) {
                console.log(response.data);
                setSuccess(true);
                navigate(`/project/${projectId}`);
            } else {
                console.error('Invalid response:', response);
                setErrors({ name: 'Invalid response from the server' });
            }
        } catch (error) {
            console.error('Error:', error.response ? error.response.data : error.message);
            setErrors({ name: error.response ? error.response.data.error : error.message });
        }
    };

    return (
        <div>

            <form onSubmit={handleSubmit}>
                <div>
                    <label className="name">Name:</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <button type="submit">Submit</button>
            </form>
            {success && <p>Facility area created successfully!</p>}
            {errors && (
                <div>
                    {Object.values(errors).map((error, index) => (
                        <p key={index}>{error}</p>
                    ))}
                </div>
            )}
        </div>
    );
}

export default CreateFacilityArea;
